// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"716545b9","124":"cb4631c0","310":"b3ef4e5b","460":"70bf8963","906":"b504438a","913":"0b101953"}[chunkId] + ".chunk.js";
};